import React from 'react';

// import { useNetInfo } from '@react-native-community/netinfo';

import { Colors } from 'theme/colors';
import { NakedIcon } from 'theme/icons';
import { Container } from 'theme/layout';
import { Regular } from 'theme/text';

import { Banner } from './styles';
/**
 * Renders an error message when there are some
 * connection issues.
 *
 * @param props - Render props.
 */
export function ConnectionError(props: ConnectionErrorProps) {
  const { isConnected } = props;

  if (isConnected) {
    return null;
  }

  return (
    <Banner>
      <NakedIcon size={20} color={Colors.white} name="exclamation-circle" />
      <Container ml={2}>
        <Regular color={Colors.white}>Please check your connection</Regular>
      </Container>
    </Banner>
  );
}
export interface ConnectionErrorProps {
  /** If true, indicates that an Internet connection is present. */
  isConnected: boolean;
}
